module.exports = __webpack_public_path__ + "img/location-map-pin.79247a08.svg";